import script from "./SpendingTreemapPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingTreemapPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingTreemapPage.vue?vue&type=style&index=0&id=9e366846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e366846"]])

export default __exports__